export const HOUSE_PATH = "M32 9 56 28 52 32 50 30.5V52H14V30.5L12 32 8 28Z";

const Halves = ({ id }) => (
  <>
    <defs>
      <clipPath id={`${id}-l`}><rect x="0" y="0" width="32" height="64" /></clipPath>
      <clipPath id={`${id}-r`}><rect x="32" y="0" width="32" height="64" /></clipPath>
    </defs>
    <g strokeWidth="3.5" strokeLinejoin="round">
      <path d={HOUSE_PATH} clipPath={`url(#${id}-l)`} fill="rgb(var(--t-primary))" stroke="rgb(var(--t-primary))" />
      <path d={HOUSE_PATH} clipPath={`url(#${id}-r)`} fill="rgb(var(--t-c2))" stroke="rgb(var(--t-c2))" />
    </g>
  </>
);

export const HomeBalanceIcon = () => (
  <svg viewBox="0 0 64 64" className="h-8 w-8" data-testid="logo-icon" aria-label="Base and Balance logo">
    <Halves id="bb" />
    <circle cx="32" cy="36" r="5.5" fill="rgb(var(--t-card))" />
  </svg>
);

export const LogoLoader = () => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-5 relative z-10" data-testid="app-loading">
    <svg viewBox="0 0 64 64" className="h-24 w-24" aria-label="Loading Base and Balance">
      <defs>
        <clipPath id="bb-fill"><rect className="logo-fill-rect" x="0" y="0" width="64" height="64" /></clipPath>
      </defs>
      <path d={HOUSE_PATH} fill="none" stroke="rgb(var(--t-line-strong))" strokeWidth="3.5" strokeLinejoin="round" />
      <g clipPath="url(#bb-fill)"><Halves id="bb-load" /></g>
      <circle cx="32" cy="36" r="5.5" fill="rgb(var(--t-bg))" />
    </svg>
    <p className="font-serif-display text-2xl text-t-ink logo-fade">Base and Balance</p>
  </div>
);
